
import React from 'react';
import { Badge } from 'antd';
import { restrictedLevel, is, STATUS, isRestricted, ROLE } from '../admin/events/Constants';
import { connect } from 'react-redux';

function badge(props) {
    const event = props.event;
    const restricted = restrictedLevel(event);

    return <Badge status={ 
        (props.is.admin 
        || !isRestricted(event)
        || (restricted.role === ROLE.STUDENT && (props.is.ynov))
        || (restricted.role === ROLE.FOREIGNER && props.is.auth && !props.is.ynov )
        || restricted.role === ROLE.VISITOR ?
          ( is(event, true) === STATUS.ONGOING ? "processing" : 'success' ) : 
        'error')
    } text={props.text || event.title}>
      { props.children }
    </Badge>
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    is: {
      ynov: state.authentification.isYnov,
      auth: state.authentification.isAuth,
      admin: state.authentification.isAdmin,
    }
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(badge);


// WEBPACK FOOTER //
// ./src/features/event/Badge.js